import React, { useEffect, useState } from "react";
import JobDetailsTab from "../ViewJobModalTabs/JobDetailsTab/JobDetailsTab";
import TrucksTab from "../ViewJobModalTabs/TrucksTab/TrucksList/TruckLists";
import NotesTab from "../ViewJobModalTabs/NotesTab/NotesTab";
import InvoiceTab from "../ViewJobModalTabs/InvoiceTab/InvoiceTab";
import AuditTrailTab from "../ViewJobModalTabs/AuditTrailTab/AuditTrailTab";

import closeIcon from "../../../../../../Assets/images/close-icon.svg";
import apiClient from "../../../../../../Config/apiClient";
import { ClipLoader } from "react-spinners";

const jobsPath = process.env.REACT_APP_HS_JOBS_BASE_PATH
const notesPath = process.env.REACT_APP_HS_NOTES_BASE_PATH

const ViewJobModal = ({ jobId, refresh, onStatusChange }) => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [jobData, setJobData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [auditTrailData, setAuditTrailData] = useState([]);
  const [notesData, setNotesData] = useState([]);

  const fetchNotes = async () => {
    try {
      const response = await apiClient.get(`${notesPath}/list?jobId=${jobId}`);
      if (response?.data?.status === "SUCCESS") {
        setNotesData(response.data.data );
      } else {
        setNotesData([]);
      }
    } catch (error) {
      console.error("Failed to fetch notes:", error);
      setNotesData([]);
    }
  };

  const fetchAuditTrail = async () => {
    try {
      const response = await apiClient.get(`${jobsPath}/audit-trail?jobId=${jobId}`);
      if (response?.data?.status === 'SUCCESS') {
        setAuditTrailData(response.data.data);
      } else {
        setAuditTrailData([]);
      }
    } catch (err) {
      console.error('Failed to fetch audit trail:', err);
      setAuditTrailData([]);
    }
  };

  useEffect(() => {
    const modalEl = document.getElementById("viewJob");

    const handleModalOpen = () => {
      setActiveTab("tab1");
    };

    if (modalEl) {
      modalEl.addEventListener("show.bs.modal", handleModalOpen);
    }

    return () => {
      if (modalEl) {
        modalEl.removeEventListener("show.bs.modal", handleModalOpen);
      }
    };
  }, []);

  useEffect(() => {
    if (!jobId) return;

    const fetchJobDetails = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get(`${jobsPath}/get?id=${jobId}`);
        if (response?.data?.status === "SUCCESS") {
          const job = response.data.data;

          setJobData(job);

          await fetchAuditTrail();
          //await fetchNotes();
        }
      } catch (error) {
        console.error("Failed to fetch job details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobDetails();
  }, [jobId, refresh]);

  return (
    <>
      <div className="modal right rtm-modal fade" id="viewJob" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="viewJobLabel" aria-hidden="true">
        <div className="modal-dialog rtl-dialog">
          <div className="modal-content rtl-content vjob-content animate__animated animate__fadeInRight" style={{ maxHeight: "100vh", overflow: "hidden" }}>
            <div className="ajob-content" style={{ maxHeight: "70px", overflowY: "auto" }}>
              <div className="cpf-top-no-title">
                <button className="m-close" data-bs-dismiss="modal">
                  <img src={closeIcon} alt="close" />
                </button>
              </div>

              <div className="viewjob-inner">
                <div className="aptab-header mt-3">
                  <ul className="nav nav-tabs tab-line" id="myTab" role="tablist">
                    {[
                      { id: "tab1", label: "Job Details" },
                      { id: "tab2", label: "Trucks" },
                      //{ id: "tab3", label: "Notes" },
                      { id: "tab4", label: "Invoice" },
                      { id: "tab5", label: "Audit Trail" },
                    ].map(({ id, label }) => (
                      <li className="nav-item" role="presentation" key={id}>
                        <button className={`nav-link tab-btn ${activeTab === id ? "active" : ""}`} onClick={() => setActiveTab(id)}>
                          {label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="aptab-body">
                  <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" role="tabpanel">
                      {loading ? (
                        <div className="text-center">
                          <ClipLoader size={40} color="gray" />
                        </div>
                      ) : (
                        <>
                          <div style={{ display: activeTab === "tab1" ? "block" : "none" }}>
                            <JobDetailsTab jobData={jobData} refresh={refresh} onStatusChange={onStatusChange} triggerAddModal={() => {}} />
                          </div>
                          <div style={{ display: activeTab === "tab2" ? "block" : "none" }}>
                            <TrucksTab jobId={jobId} jobData={jobData} refresh={refresh} />
                          </div>
                          {/* <div style={{ display: activeTab === "tab3" ? "block" : "none" }}>
                            <NotesTab notes={notesData} setNotes={setNotesData} selectedJobId={jobId} />
                          </div> */}
                          <div style={{ display: activeTab === "tab4" ? "block" : "none" }}>
                            <InvoiceTab jobId={jobId} />
                          </div>
                          <div style={{ display: activeTab === "tab5" ? "block" : "none" }}>
                            <AuditTrailTab auditTrailData={auditTrailData} />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewJobModal;
